import { render, staticRenderFns } from "./WrapperWidgetTable.vue?vue&type=template&id=19a14db4&"
import script from "./WrapperWidgetTable.vue?vue&type=script&lang=js&"
export * from "./WrapperWidgetTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports